import { Card } from "antd";
import Title from "antd/lib/typography/Title";
import styled from "styled-components";

export const StyledHeaderImage = styled.img`
  width: 100%;
  height: 320px;
  object-fit: cover;
  overflow: hidden;
`;

export const StyledDiv = styled.div`
  position: relative;
  width: 100%;
`;

export const StyledCardWrapper = styled(Card)`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: var(--neutral);
  padding: 0em 3em;
  height: 80px;
  .ant-card-body {
    padding: 18px;
  }
`;

export const StyledTitle = styled(Title)`
  white-space: nowrap;
`;
